import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { GenericListPage } from '../../components/generic';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';
import { useWrhDays, type WrhDay } from './useData';

const List: React.FC = () => {
  const { colors } = useTheme();
  const config = useMemo(
    () => ({
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    }),
    [],
  );

  return (
    <div>
      <div className={cn('mx-auto flex max-w-[100vw] flex-wrap gap-3 px-4 pt-4 sm:px-6', colors.textSecondary)}>
        <Link to="/wrh/sheet" className="text-sm font-medium text-indigo-600 hover:underline">
          Month sheet
        </Link>
        <Link to="/wrh/arrangements" className="text-sm font-medium text-indigo-600 hover:underline">
          Arrangements
        </Link>
        <Link to="/wrh/rules" className="text-sm font-medium text-indigo-600 hover:underline">
          Rules
        </Link>
        <Link to="/wrh/operation-types" className="text-sm font-medium text-indigo-600 hover:underline">
          Operation types
        </Link>
        <Link to="/vessel-operations" className="text-sm font-medium text-indigo-600 hover:underline">
          Vessel operations
        </Link>
        <Link to="/wrh/compliance" className="text-sm font-medium text-indigo-600 hover:underline">
          Compliance report
        </Link>
        <Link to="/wrh/reports" className="text-sm font-medium text-indigo-600 hover:underline">
          Weekly summary
        </Link>
      </div>
      <GenericListPage<WrhDay> useData={useWrhDays} config={config} />
    </div>
  );
};

export default List;
